import axiosInstance from '../utils/axiosConfig';

interface LoginResponse {
  code: number | string;
  message: string;
  data: {
    token: string;
    username: string;
    require_confirm?: boolean;
  } | null;
  requireConfirm?: boolean;
  success?: boolean;
}

export const login = async (username: string, password: string, force: boolean = false): Promise<LoginResponse> => {
  try {
    const response = await axiosInstance.post('/auth/login', {
      username,
      password,
      force_login: force
    });

    const { data } = response;
    
    // 如果需要确认
    if (data.code === 'CONFIRM_REQUIRED') {
      return {
        code: 'CONFIRM_REQUIRED',
        requireConfirm: true,
        message: data.message,
        data: null
      };
    }

    // 登录成功，保存token
    if (data.code === 200 && data.data && data.data.token) {
      localStorage.setItem('token', data.data.token);
      localStorage.setItem('username', data.data.username);
      return {
        code: 200,
        success: true,
        message: data.message,
        data: data.data,
        requireConfirm: false
      };
    }

    // 其他情况
    return {
      code: data.code,
      success: false,
      message: data.message,
      data: null,
      requireConfirm: false
    };
  } catch (error) {
    throw error;
  }
};


export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  // Navigation will be handled by the components
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};

export const getCurrentUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const setAuthHeader = (token: string) => {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const removeAuthHeader = () => {
  delete axiosInstance.defaults.headers.common['Authorization'];
};

export const changePassword = async (oldPassword: string, newPassword: string) => {
  try {
    const response = await axiosInstance.post('/auth/change-password', {
      oldPassword,
      newPassword
    });
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('修改密码失败，请重试');
  }
}; 